import { createSelector } from 'reselect';
import { portfolioSelector } from '@/components/DeprecatedPortfolio/redux/selectors';
import type { HoldingDividend } from './interface';
import { get } from 'lodash';

export const holdingsByDividendSelector = createSelector(
  [portfolioSelector],
  (portfolio): HoldingDividend[] => {
    const holdings = get(portfolio, ['holdings'], []);
    return holdings
      .filter(
        (n) =>
          n.name !== undefined &&
          typeof n.currentDividend === 'number' &&
          n.currentDividend !== 0 &&
          typeof n.currentValue === 'number' &&
          n.currentValue !== 0
      )
      .map(({ companyId, name, currentDividend, currentValue }) => ({
        companyId,
        companyName: name as string,
        currentValue: currentValue as number,
        currentDividend: currentDividend as number,
      }))
      .sort((a, b) => {
        if (a.currentDividend < b.currentDividend) return 1;
        else if (a.currentDividend > b.currentDividend) return -1;
        else return 0;
      });
  }
);
